export const DISNEY_PLUS_STANDARD = 'DJMHG';
export const DISNEY_PLUS_PREMIUM = 'PELYC';
export const DISNEY_PLUS_MPUID_CODES = [
  DISNEY_PLUS_STANDARD,
  DISNEY_PLUS_PREMIUM,
];
export const PICKX_DISNEY_PLUS_MPUID_CODES = [
  'KOEVD',
  'CQGHE',
  'KGZVI',
  'PWKON',
];

export const SCARLET_SPORTS_STANDARD = 'MYDEV';
export const SCARLET_SPORTS_PREMIUM = 'PEDNO';

export const SPORTS_STANDARD = 'DMHZS';
export const SPORTS_PREMIUM = 'MOPOJ';

export const SPORTS_PREMIUM_MPUID_CODES = [
  SPORTS_PREMIUM,
  SCARLET_SPORTS_PREMIUM,
];
export const SPORTS_STANDARD_MPUID_CODES = [
  SPORTS_STANDARD,
  SCARLET_SPORTS_STANDARD,
];

export const SPORTS_MPUID_CODES = [SPORTS_PREMIUM, SPORTS_STANDARD];
export const SCARLET_SPORTS_MPUID_CODES = [
  SCARLET_SPORTS_PREMIUM,
  SCARLET_SPORTS_STANDARD,
];
